<template>
  <div class="container">
    <b-field>
      <b-field label="Search" class="pr-2">
        <b-input
          expanded
          placeholder=" Search..."
          type="search"
          v-model="search"
        ></b-input
      ></b-field>
      <b-field label="Status" class="pr-2">
        <b-select expanded placeholder="Status" v-model="status">
          <option>No filter</option>
          <option v-for="option in statuses" :key="option.value">
            {{ option.value }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Priority" class="pr-2">
        <b-select expanded placeholder="Priority" v-model="priority">
          <option>No filter</option>
          <option v-for="option in priorities" :key="option.value">
            {{ option.value }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Responsible" class="pr-2">
        <b-select v-model="responsible" placeholder="Responsible">
          <option value="">No filter</option>
          <option v-for="option in adminUsers" :key="option.id">
            {{ option.name }}
          </option>
        </b-select>
      </b-field>
      <b-field label="Project Year" class="pr-2">
        <b-select v-model="projectYear" placeholder="Responsible">
          <option
            v-for="option in projectYears"
            :value="option.value"
            :key="option.id"
          >
            {{ option.name }}
          </option>
          <option value="">No filter</option>
        </b-select>
      </b-field>
      <b-field label="Show inactive">
        <b-checkbox v-model="inactive" />
      </b-field>
    </b-field>
    <b-table
      :row-class="() => `hover`"
      hoverable
      @click="(object) => openModal(object)"
      :data="companies"
      paginated
    >
      <template slot-scope="props">
        <b-table-column field="priority" label="Priority" sortable width="50">
          <span class="tag" :class="getPriorityClass(props.row.priority)">
            {{ props.row.priority ? props.row.priority : "None" }}
          </span>
        </b-table-column>
        <b-table-column field="display_name" label="Name" width="200" sortable>
          {{ props.row.display_name }}
        </b-table-column>
        <b-table-column field="responsible" label="Responsible" sortable>
          {{ props.row.responsible ? props.row.responsible : "None" }}
        </b-table-column>
        <b-table-column field="status" label="Status" sortable width="50">
          <span class="tag" :class="getStatusClass(props.row.status)">
            {{ props.row.status ? props.row.status : "None" }}
          </span>
        </b-table-column>
        <b-table-column
          field="last_updated"
          label="Last updated"
          width="150"
          sortable
        >
          <span class="tag is-gray"> {{ props.row.last_updated }} </span>
        </b-table-column>
      </template>

      <template #empty>
        <div class="has-text-centered">
          No companies found using this filter.
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditCompany from "./EditCompany";
import Options from "./options";
import ProjectYears from "../../../helpers/projectYears";

export default {
  data: () => {
    return {
      statuses: { ...Options.statusOptions },
      priorities: { ...Options.priorityOptions },
      projectYears: ProjectYears.projectYears,
    };
  },
  computed: {
    ...mapGetters({
      companies: "admin/companies/getCompanies",
      adminUsers: "admin/getAdminUsers",
    }),
    search: {
      get: function () {
        return this.$store.state.admin.companies.searchString;
      },
      set: function (value) {
        this.$store.dispatch("admin/companies/updateSearch", value);
      },
    },
    priority: {
      get: function () {
        return this.$store.state.admin.companies.priority;
      },
      set: function (value) {
        this.$store.dispatch("admin/companies/updatePriority", value);
      },
    },
    status: {
      get: function () {
        return this.$store.state.admin.companies.status;
      },
      set: function (value) {
        this.$store.dispatch("admin/companies/updateStatus", value);
      },
    },
    responsible: {
      get: function () {
        return this.$store.state.admin.companies.responsible;
      },
      set: function (value) {
        this.$store.dispatch("admin/companies/updateResponsible", value);
      },
    },
    projectYear: {
      get: function () {
        return this.$store.state.admin.companies.projectYear;
      },
      set: function (value) {
        this.$store.dispatch("admin/companies/updateProjectYear", value);
      },
    },
    inactive: {
      get: function () {
        return this.$store.state.admin.companies.inactive;
      },
      set: function (value) {
        this.$store.dispatch("admin/companies/updateInactive", value);
      },
    },
  },
  methods: {
    openModal(data) {
      this.$ga.event({
        eventCategory: "companies",
        eventAction: "Clicked company",
        eventLabel: "table",
      });
      this.$modal.open({
        parent: this,
        component: EditCompany,
        props: { company_key: data.company_key },
        hasModalCard: true,
      });
    },
    getStatusClass(status) {
      switch (status) {
        case "Booked":
          return "is-success";
        case "Meeting":
          return "is-warning";
        case "Contacted":
          return "is-orange";
        case "Call later":
          return "is-info";
        case "No":
          return "is-danger";
        default:
          return "is-white";
      }
    },
    getPriorityClass(priority) {
      switch (priority) {
        case "High":
          return "is-danger";
        case "Medium":
          return "is-orange";
        case "Low":
          return "is-success";
        default:
          return "is-white";
      }
    },
    getLastUpdated(lastModified) {
      return lastModified
        ? lastModified.toDate().toISOString().slice(0, 10)
        : "None";
    },
  },
};
</script>

<style lang="css">
.hover {
  cursor: pointer;
}
</style>
